<template>
  <div v-if="!isEmpty(errors)" class="form-input-error">
    <div v-for="message in errors" :key="message">
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  name: 'FormInputError',

  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    isEmpty,
  },
}
</script>

<style scoped>
.form-input-error {
  font-size: 12px;
  left: 5px;
  color: var(--c-secondary-color-1);
}
</style>
